import capitalize from 'capitalize-pt-br';

export function isBlank(text: string): boolean {
  return text.trim().length === 0;
}

export function isUpper(text: string): boolean {
  return text === text.toUpperCase();
}

export function toNameCase(text: string): string {
  if (isUpper(text)) {
    return capitalize(text);
  }

  return text;
}
